
<ng-container *ngIf="(ie.CustomizeOptions != null)">
  <div *ngIf="(ie.CustomizeOptions.DisplayType == 'progressbar')">
    <progressbar class="progress progress-striped active" 
      [max]="ie.CustomizeOptions.Properties.ProgBarMax"
      [value]="ie.CustomizeOptions.Properties.ProgBarValue"
      type="info">
    </progressbar>
  </div>
</ng-container>
<span (click)="loadAppPageFromHistory()" [class]="class" *ngIf="(labelDisplayType == 'simple'); else labelFormats">
  {{ie.Label.DisplayName}}
</span>
<!--<p [class]="class" *ngIf="(labelDisplayType == 'simple'); else labelFormats" >
  {{ie.Label.DisplayName}}
</p>-->
<ng-template #labelFormats>
  <div *ngIf="(ie.Label.DisplayName == '' )">
    <h4>
      <b>{{ie.Label.TextShort}}</b>
    </h4>
    <p class="text-muted" [innerHTML]="ie.Label.TextLong"></p>
  </div>
  <div *ngIf="(ie.Label.DisplayName !='' && ie.Label.TextLong != '')">
    <section class="padding-xxs">
      <div class="">
        <h5>{{ie.Label.DisplayName}}</h5>
        <p class="text-muted" [innerHTML]="ie.Label.TextLong"></p>
      </div>
    </section>
  </div>
  <div *ngIf="(ie.Label.DisplayName != '' && ie.Label.TextShort != '')">
    <b>{{ie.Label.DisplayName}} : </b>
    <span> {{ie.Label.TextShort}}</span>
  </div>
  <div class="element-spacing" *ngIf="(ie.Label.DisplayName != '') &&
    ie.Label.TextShort == '' &&
    ie.Label.TextLong == ''">
    <span>{{ie.Label.DisplayName}}</span>
  </div>
</ng-template>

